import '../../modules/mode-components';

import * as angular from 'angular';

import CreateGroupModalController from './create-group-modal-controller';
import template from './create-group-modal.html';

const renameGroupDirective = function (Modal, GroupModel, AlertService) {
  return {
    restrict: 'A',
    scope: {
      group: '<',
      owner: '<',
    },
    link: function ($scope: any, elem, attrs) {
      elem.on('click.context', (event) => {
        const modal = Modal.open(
          {
            existingGroup: $scope.group,
            owner: $scope.owner,
          },
          {
            controller: CreateGroupModalController,
            controllerAs: 'ctrl',
            bindToController: true,
            template: template,
          }
        );

        modal.result
          .then((group) => {
            GroupModel.update($scope.group, { 'user_group.name': group.name })
              .then(() => {
                $scope.group.name = group.name;
                AlertService.success('Renamed Group');
              })
              .catch(() => AlertService.error('Failed to rename Group'));
          })
          .catch(function () {});
      });

      // cleanup handlers
      $scope.$on('$destroy', () => elem.off('click.renameGroup'));
    },
  };
};

renameGroupDirective.$inject = ['ModalService', 'GroupModel', 'ToastService'];

angular.module('mode.components').directive('renameGroup', renameGroupDirective);
